<script>
import { Doughnut } from 'vue-chartjs'

export default {
  extends: Doughnut,
  props: {
    labels: {
      type: Array,
      required: true
    },
    datasets: {
      required: true
    }
  },
  methods: {
    render () {
      if (this.$data._chart != null) {
        this.$data._chart.data.labels = this.labels
        this.$data._chart.data.datasets = this.datasets
        this.$data._chart.update()
      } else {
        this.renderChart({
          labels: this.labels,
          datasets: this.datasets
        }, {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            display: false
          }})
      }
    }
  },
  mounted () {
    this.render()
  },
  watch: {
    labels: function (val) {
      this.render()
    },
    'datasets.0.data': function (val) {
      this.render()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/charts/Doughnut.vue